/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-debugger */
/* eslint-disable no-console */
/* eslint-disable react/self-closing-comp */
/* eslint-disable import/named */
/* eslint-disable prefer-template */
/* eslint-disable one-var */
/* eslint-disable radix */
/* eslint-disable no-else-return */
/* eslint-disable no-shadow */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-expressions */
/* eslint-disable react/jsx-boolean-value */
/* eslint-disable vars-on-top */
/* eslint-disable eqeqeq */
/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-var */
/* eslint-disable camelcase */
/* eslint-disable arrow-body-style */
/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable object-shorthand */
/* eslint-disable no-unused-vars */
/* eslint-disable no-use-before-define */
/* eslint-disable prefer-const */
/* eslint-disable dot-notation */
/* eslint-disable no-nested-ternary */
/* eslint-disable prefer-arrow-callback */

import React, { useEffect, useState, useReducer } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import PropTypes, { object } from "prop-types";
import clsx from "clsx";
import {
  Modal,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  Button as MuiButton,
} from "@material-ui/core";
import { useHistory, useParams } from "react-router-dom";
import DeleteIcon from "@mui/icons-material/Delete";
import ArrowCircleLeftIcon from '@mui/icons-material/ArrowCircleLeft';
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import { MdReplay } from "react-icons/md";

import {
  CustomFormGroup,
  CustomSelect,
  ValidatingTextField,
} from "../FormComponents";
import {
  DATE_FORMAT,
  API_RESOURCE_URLS,
  DISPLAY_MESSAGES,
  MESSAGE_TYPE,
  RESOURCE_TYPE,
  USER_OPERATIONS,
  Regex,
} from "../../constants";
import { usePopupManager } from "../../providers/PopupManager/PopupManager";
import { AuthChecker, Button } from "../../atomicComponents";
import { withAllowedOperationsProvider } from "../../hocs";
import TableSimple from "../../atomicComponents/TableSimple1/TableSimple";
import MultiSelects from "../FormComponents/MultiSelects";
import { setLogin } from '../../redux/features/auth/actions';
import Truckloading from "../CvLoader/Cvloader";
import useDebounceSearch from "../../hooks/useDebounceSearch";
import { sanitizeNumeric } from "../../utils/utils";
import apiService from "../../apis/apiService";
import styles from "./AccessControlForm.module.css"

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const initialState = {
  plant: null,
  part: null,
  aqCommodity: null,
  purchaseCommodity: null,
  supplierCode: null,
  supplierDetails: null,
  supplierName: "",
  supplierLocation: "",
  selectedProject: null,
  selectedPO: null,
  inputFields: {
    purchaseBuyerName: "",
    suppRepresentativeName: "",
    suppRepresentativeContact: "",
    suppRepresentativeEmail: "",
  },
  errors: {},
};
const reducer = (state, action) => {
  switch (action.type) {
    case "update":
      return {
        ...state,
        [action.field]: action.value,
      };
    case "reset":
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};

function AccessControlForm({
  auth,
}) {
  
  const ROW_HEIGHT = 38;
  const [loadingTruck, setLoadingTruck] = React.useState(false);
  const [state, dispatch] = useReducer(reducer, initialState);
  const { showPopup } = usePopupManager();
  const history = useHistory();
  const dispatchNew= useDispatch();
  let {
    userName,
    personNumber,
    companyCode,
    bookingStatus,
    costCenter,
    userRole,
    sessionId,
    apiSendData
  } = auth;
  console.log(
    "Login Details of the user -> ",
    userName,
    personNumber,
    companyCode,
    bookingStatus,
    costCenter,
    userRole,
    sessionId
  );
  const {
    inputFields,
    errors,
  } = state;

  const [suppliers, getSuppliers] = useState({ loading: false, data: [] });
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [BCDetails, setBCDetails] = useState([]);
  const [confirmModalFlag, setConfirmModal] = useState(false);
  const [confirmModalFlag2, setConfirmModal2] = useState(false);
  const [deleteParam, handleDeleteParam] = useState();
  const [deleteParam2, handleDeleteParam2] = useState();
  const [resetAllVisitedFields, setResetAllVisitedFields] = useState(false);
  const [highlightMandatoryFields, setHighlightMandatoryFields] =
    useState(false);
  const [userRemark, setUserRemark] = useState("");
  const [bcHeadDisable, setBCHeadDisable] = useState(false);
  const [bcRemark, setBcRemark] = useState("");
  const [SARemark, setSARemark] = useState("");
  const [eDetails, setEDetails] = useState("");
  const [personName, setPersonName] = React.useState([]);
  const [role, setRole] = useState([
    { value: "DS", label: "Departmental SPOC" },
    { value: "SUP", label: "Supervisor" },
  ]);
  const [onChange, setOnChange] = useState(false);
  // console.log("role", role);
  const [dropDownValue, setDropDownValue] = useState([]);
  // console.log("dropDownValue", dropDownValue.value);
  const [selectedData, setSelectedData] = useState({
    Work_Area: "",
    Location: "",
    Pune: "",
    Jamshedpur: "",
    Lucknow: "",
  });
  const [disableButton,setDisableButton]=useState(false)
  const [currentUserData, setCurrentUserData] = useState([]);
  const [newUserData, setNewUserData] = useState({});
  const [existingBC, setExistingBC] = useState([]);

  const [currentTicket, setCurrentTicket] = useState("");
  const [newAccessTicket, setNewAccessTicket] = useState("");
  const hasSARole = userRole.includes("SA");
  const [disableTicketNumber, setDisableTicketNumber] = useState(false);
  const[requestTypes,setRequestTypes]=useState([]);
  const [error, setError] = useState("");
  
  const [apiPayloadData, setAPIPaylodData] = useState(apiSendData);
  const searchByTicket =  useDebounceSearch(eDetails)
  const searchByCurrentTicket = useDebounceSearch(currentTicket);
  const searchByNewTicket = useDebounceSearch(newAccessTicket)
  const isValidInput = (input) => {
    const validCharacters =/^[a-zA-Z0-9.,/&?' -]+$/;
    return validCharacters.test(input);
  };

 const handleBcChange=(selectedOption)=>{
    if(selectedOption)
    {
    setSelectedBC(selectedOption);
    }
    else{
      setSelectedBC([])
    }

  }
  const handleSelectChange = (event) => {
    const value = event.target.value;
    setRequestType(value);
    console.log("dropDownValue.length, value: ", dropDownValue.length, dropDownValue.value);
    // Check if the selected value is empt  y and set an error message
    if(!value){
      setError('');
    }
    else if(dropDownValue.length == 0 || dropDownValue.value == undefined){
        setError('Please select a Role');
      } 
    else{
        setError('');
      }
  };

  const renderTicketEmpDetails = () => (
    <div className={styles.formGroup}>
      <Grid container spacing={1} style={{ marginTop: "10px" }} columns={12}>
        <Grid item md={2} lg={2} xs={2}>
          <div className={styles.rowDiv}>
            <div className={styles.lableDiv2}>
              <label>Employee Details</label>
            </div>
          </div>
        </Grid>
        {loadingTruck ? (
          <div style={{textAlign:"center",display:"flex",justifyContent:"center",marginTop:"40px"}}>
               <Truckloading />
            </div>):
          // <CustomFormGroup header="Report Details" body={renderReport()} />
          <> <Grid item md={10} lg={10} xs={10}>
          <TableSimple
            tableColumnData={[
              {
                ticket: emp_app_details[0]?.pers_no || "",
                empName: emp_app_details[0]?.employee_name || "",
                bcNo: emp_app_details[0]?.bc_no || "",
                bcDesc: emp_app_details[0]?.costcenter_name || "",
                workArea: emp_app_details[0]?.workarea || "",
                requestId: request_type.activeId
              },
            ]}
            tableHeaderLabel={[
              "Ticket No_50",
              "Employee Name_80",
              "BC No_38",
              "BC Description_120",
              "Work Area_80",
              "Request Id_50"
            ]}
            TableRowHederAling="start"
            size="small"
            headerColor="#E6F2FF"
            className="custom-table"
          />
        </Grid></>
        }
       
      </Grid>
    </div>
  );

  const renderTransferEmpDetails = () => (
    <div className={styles.formGroup}>
      <Grid container spacing={1} style={{ marginTop: "10px" }} columns={12}>
        <Grid item md={2} lg={2} xs={2}>
          <div className={styles.rowDiv}>
            <div className={styles.lableDiv2}>
              <label>Employee Details</label>
            </div>
          </div>
        </Grid>
        <Grid item md={10} lg={10} xs={10}>
          <TableSimple
            tableColumnData={[
              {
                type: "Current",
                ticket: currentUserData?.pers_no || "",
                empName: currentUserData?.employee_name || "",
                bcNo: currentUserData?.bc_no || "",
                bcDesc: currentUserData?.costcenter_name || "",
                workArea: currentUserData?.workarea || "",
              },
              {
                type: "Propose",
                ticket: newUserData.pers_no ?? "",
                empName: newUserData.employee_name ?? "",
                bcNo: newUserData.bc_no ?? "",
                bcDesc: newUserData.costcenter_name ?? "",
                workArea: newUserData.workarea ?? "",
              },
            ]}
            tableHeaderLabel={[
              "_30 ",
              "Ticket No_50",
              "Employee Name_100",
              "BC No._60",
              "BC Description_100",
              "Work Area_100",
            ]}
            TableRowHederAling="start"
            size="small"
            headerColor="#E6F2FF"
            className="custom-table"
          />
        </Grid>
      </Grid>
    </div>
  );

  const renderTicketApprovalDetailsDelete = () => (
    <div className={styles.formGroup}>
      <Grid container spacing={1} style={{ marginTop: "10px" }} columns={12}>
        <Grid item md={2} lg={2} xs={2}>
          <div className={styles.rowDiv}>
            <div className={styles.lableDiv2}>
              <label>Approval Details</label>
            </div>
          </div>
        </Grid>
        <Grid item md={10} lg={10} xs={10}>
          <TableSimple
            tableColumnData={[
              {
                ticket:
                  removeDeleteIdentifier === "remove"
                    ? currentUserData?.bc_head_persno || ""
                    : newUserData?.bc_head_persno || "",
                empName:
                  removeDeleteIdentifier === "remove"
                    ? currentUserData?.bchead_name || ""
                    : newUserData?.bchead_name || "",
                bcNo:
                  removeDeleteIdentifier === "remove"
                    ? currentUserData?.bc_no || ""
                    : newUserData?.bc_no || "",
                bcDesc:
                  removeDeleteIdentifier === "remove"
                    ? currentUserData?.costcenter_name || ""
                    : newUserData?.costcenter_name || "",
                workArea:
                  removeDeleteIdentifier === "remove"
                    ? currentUserData?.workarea || ""
                    : newUserData?.workarea || "",
              },
            ]}
            tableHeaderLabel={[
              "Ticket No_50",
              "Employee Name_150",
              "BC No._60",
              "BC Description_150",
              "Work Area_100",
            ]}
            TableRowHederAling="start"
            size="small"
            headerColor="#E6F2FF"
            className="custom-table"
          />
        </Grid>
      </Grid>
    </div>
  );

  const renderTicketBcDetails = () => (
    <div className={styles.formGroup}>
      <Grid container spacing={1} style={{ marginTop: "10px" }} columns={12}>
        <Grid item md={2} lg={2} xs={2}>
          <div className={styles.rowDiv}>
            <div className={styles.lableDiv2}>
              <label>BC Details</label>
            </div>
          </div>
        </Grid>
        <Grid item md={10} lg={10} xs={10}>
          <TableSimple
            tableColumnData={[
              {
                workArea:
                  removeDeleteIdentifier === "remove"
                    ? requestBcDetails?.workarea || ""
                    : requestBcDetails[0]?.workarea || "",
                location:
                  removeDeleteIdentifier === "remove"
                    ? requestBcDetails?.location || ""
                    : requestBcDetails[0]?.location || "",
                bcNo:
                  removeDeleteIdentifier === "remove"
                    ? requestBcDetails?.description || ""
                    : requestBcDetails[0]?.description || "",
              },
            ]}
            tableHeaderLabel={["Work Area_70", "Location_30", "Description_120"]}
            TableRowHederAling="start"
            size="small"
            headerColor="#E6F2FF"
            className="custom-table"
          />
        </Grid>
      </Grid>
    </div>
  );

  const ApproveButtons = () => (
    <div className={styles.formGroup}>
      <Grid
        container
        spacing={1}
        className={styles.myGrid}
        style={{ marginTop: "10px", justifyContent: "center" }}
        columns={12}
      >
        <Grid item md={4} lg={4}>
          <div className={styles.rowDiv}>
            <div className={styles.formDiv}>
              <Button
                className={clsx(
                  styles.actionButton,
                  styles.primaryActionButton
                 )}                                                                                                                              
                variant="primary"
                onClick={handleApproval}
                //     disabled={(myState.chassisNo == null)}
                data-testid="confirm-action"
                style={{ marginRight: "100px" }}
              >
                Approve
              </Button>

              <Button
                className={clsx(styles.actionButton, styles.resetButton)}
                variant="tertiary"
                onClick={handleRejection}
                //     disabled={(myState.chassisNo == null)}
                data-testid="confirm-action"
                style={{ marginLeft: "50px" }}
              >
                Reject
              </Button>
            </div>
          </div>
        </Grid>
      </Grid>
    </div>
  );

  const request_type = useParams();
  console.log(
    "Request Id from Additional Access -> ",
    request_type.requestType,
    request_type.activeId
  );

  const [disable, setDisable] = useState(false);
  const [removeDeleteIdentifier, setRemoveDeleteIdentifier] = useState("");
  const [requestRole, setRequestRole] = useState("");
  const [requestBcDetails, setRequestBcDetails] = useState([]);

  useEffect(() => {
    if (request_type.requestType != undefined) {
     window.addEventListener('popstate', function(event) {
      const reqtype = request_type.requestType.split("-").shift();
      if (reqtype === "PL") {
        history.push("/linkage-dashboard");
      }
      else {
        history.push("/requestor-dashboard")
      }
    });
  }
  }, []);
  
  useEffect(() => {
    const getRequestType = async() =>{
      if (request_type.requestType != undefined) {
        setDisable(true);
        let value = {};
        const parts = request_type.requestType.split("-");
        setRequestType(parts[1]);
        setRequestRole(parts[2]);
        if (parts[2] === "SUP") {
          value = { value: parts[2], label: "Supervisor" };
        }
        if (parts[2] === "DS") {
          value = { value: parts[2], label: "Departmental SPOC" };
        }
        setDropDownValue(value);
        const data = {
          request_id: request_type.activeId,
        };
        if (request_type.requestType === "AA-NA-SUP") {
          try {
            const response = await apiService.AccessControlRequestDets(data, dispatchNew)
            dispatchNew(setLogin({...auth, recentStatus: response.status}))      
              setEmp_app_details(response?.data);
              if(response?.msg === 'Fail'){
                showPopup({
                  type: MESSAGE_TYPE.INFORMATION,
                  contextText: MESSAGE_TYPE.INFORMATION,
                  info: response?.data,
                  reloads:true,
                });
              }
          } catch (error) {
            dispatchNew(setLogin({ ...auth, recentStatus: error.response?.status }));
          }         
        }
        if (request_type.requestType === "AA-RTA-SUP") { 
          try {
            const response = await apiService.AccessControlRequestDets(data, dispatchNew)
            dispatchNew(setLogin({...auth, recentStatus: response.status}))
           
            if (response.data[0].trans_pers_no === null) {
              setRemoveDeleteIdentifier("remove");
              setCurrentUserData(response.data.data[0]);
            } else {
              setRemoveDeleteIdentifier("transfer");
              const apiData = response?.data;
              const currentUser = apiData.find(
                (item) => item.pers_no != response?.data[0].trans_pers_no
              );
              const newUser = apiData.find(
                (item) => item.pers_no === response?.data[0].trans_pers_no
              );             
              setCurrentUserData(currentUser);
              setNewUserData(newUser);
            }
            if(response?.msg === 'Fail'){
              showPopup({
                type: MESSAGE_TYPE.INFORMATION,
                contextText: MESSAGE_TYPE.INFORMATION,
                info: response?.data,
                reloads:true,
              });
            }
          } catch (error) {
            dispatchNew(setLogin({ ...auth, recentStatus: error.response.status }));
          }               
        }
        if (request_type.requestType === "AA-NA-DS") {
          try {
            const response = await apiService.AccessControlRequestDets(data, dispatchNew)
            dispatchNew(setLogin({...auth, recentStatus: response.status}))           
            setEmp_app_details(response?.data?.user_details);
            setRequestBcDetails(response?.data?.bc_details);
            if(response?.msg === 'Fail'){
              showPopup({
                type: MESSAGE_TYPE.INFORMATION,
                contextText: MESSAGE_TYPE.INFORMATION,
                info: response?.data,
                reloads:true,
              });
            }
          } catch (error) {
            dispatchNew(setLogin({ ...auth, recentStatus: error.response.status }));
          }
        }
        if (request_type.requestType === "AA-RTA-DS") {
          try {
            const response = await apiService.AccessControlRequestDets(data, dispatchNew)
            dispatchNew(setLogin({...auth, recentStatus: response.status}))    
            if(response?.msg === 'Fail'){
              showPopup({
                type: MESSAGE_TYPE.INFORMATION,
                contextText: MESSAGE_TYPE.INFORMATION,
                info: response?.data,
                reloads:true,
              });
            }
            if (response?.data?.user_details[0].trans_pers_no === null) {
              setRemoveDeleteIdentifier("remove");           
              setCurrentUserData(response?.data?.user_details[0]);
              setRequestBcDetails(response?.data?.bc_details[0]);
            } else {
              setRemoveDeleteIdentifier("transfer");
              const apiData = response?.data?.user_details;
              const currentUser = apiData.find(
                (item) =>
                  item.pers_no != response?.data?.user_details[0].trans_pers_no
              );
              const newUser = apiData.find(
                (item) =>
                  item.pers_no === response?.data?.user_details[0].trans_pers_no
              );           
              setCurrentUserData(currentUser);
              setNewUserData(newUser);
              setRequestBcDetails(response?.data?.bc_details);
            }
          } catch (error) {
            dispatchNew(setLogin({ ...auth, recentStatus: error.response.status }));
          }      
        }
      }
    }
    getRequestType()
  }, [request_type.requestType]);

  const bcHeadApproval = async() => {
    let data = {};
    if (accessRole.includes("B")) {
      if (request_type.requestType === "AA-NA-SUP") {
        data = {
          user_role: "BCHead",
          request_id: request_type.activeId,
          approval_flag: "A",
          created_by: emp_app_details[0]?.bc_head_pers_no,
          bc_head_remark: bcRemark,
        };
      }
      if (
        request_type.requestType === "AA-RTA-SUP" &&
        removeDeleteIdentifier === "remove"
      ) {
        data = {
          user_role: "BCHead",
          request_id: request_type.activeId,
          approval_flag: "A",
          created_by: currentUserData?.bc_head_persno,
          bc_head_remark: bcRemark,
        };
      }
      if (
        request_type.requestType === "AA-RTA-SUP" &&
        removeDeleteIdentifier === "transfer"
      ) {
        data = {
          user_role: "BCHead",
          request_id: request_type.activeId,
          approval_flag: "A",
          created_by: newUserData?.bc_head_persno,
          bc_head_remark: bcRemark,
        };
      }
      if (request_type.requestType === "AA-NA-DS") {
        data = {
          user_role: "BCHead",
          request_id: request_type.activeId,
          approval_flag: "A",
          created_by: emp_app_details[0]?.bc_head_pers_no,
          bc_head_remark: bcRemark,
        };
      }
      if (
        request_type.requestType === "AA-RTA-DS" &&
        removeDeleteIdentifier === "remove"
      ) {
        data = {
          user_role: "BCHead",
          request_id: request_type.activeId,
          approval_flag: "A",
          created_by: currentUserData?.bc_head_pers_no,
          bc_head_remark: bcRemark,
        };
      }
      if (
        request_type.requestType === "AA-RTA-DS" &&
        removeDeleteIdentifier === "transfer"
      ) {
        data = {
          user_role: "BCHead",
          request_id: request_type.activeId,
          approval_flag: "A",
          created_by: newUserData?.bc_head_pers_no,
          bc_head_remark: bcRemark,
        };
      }
      console.log("Data from BcHead Approval -> ", data);
      try {
        const response = await apiService.Additionalaccessapprovalreject(data, dispatchNew)
        dispatchNew(setLogin({...auth, recentStatus: response.status}))
        showPopup({
          type: MESSAGE_TYPE.SUCCESS,
          contextText: MESSAGE_TYPE.SUCCESS,
          info: "Request Approved for : " + request_type.activeId,
          reloads:true,
        });
        history.push("/requestor-dashboard");
      } catch (error) {
        dispatchNew(setLogin({ ...auth, recentStatus: error.response.status }));
      }
    }
  };

  const bcHeadReject = async() => {
    let data = {};
    if (accessRole.includes("B")) {
      if (request_type.requestType === "AA-NA-SUP") {
        data = {
          user_role: "BCHead",
          request_id: request_type.activeId,
          approval_flag: "R",
          created_by: emp_app_details[0]?.bc_head_pers_no,
          bc_head_remark: bcRemark,
        };
      }
      if (
        request_type.requestType === "AA-RTA-SUP" &&
        removeDeleteIdentifier === "remove"
      ) {
        data = {
          user_role: "BCHead",
          request_id: request_type.activeId,
          approval_flag: "R",
          created_by: currentUserData?.bc_head_persno,
          bc_head_remark: bcRemark,
        };
      }
      if (
        request_type.requestType === "AA-RTA-SUP" &&
        removeDeleteIdentifier === "transfer"
      ) {
        data = {
          user_role: "BCHead",
          request_id: request_type.activeId,
          approval_flag: "R",
          created_by: newUserData?.bc_head_persno,
          bc_head_remark: bcRemark,
        };
      }
      if (request_type.requestType === "AA-NA-DS") {
        data = {
          user_role: "BCHead",
          request_id: request_type.activeId,
          approval_flag: "R",
          created_by: emp_app_details[0]?.bc_head_pers_no,
          bc_head_remark: bcRemark,
        };
      }
      if (
        request_type.requestType === "AA-RTA-DS" &&
        removeDeleteIdentifier === "remove"
      ) {
        data = {
          user_role: "BCHead",
          request_id: request_type.activeId,
          approval_flag: "R",
          created_by: currentUserData?.bc_head_pers_no,
          bc_head_remark: bcRemark,
        };
      }
      if (
        request_type.requestType === "AA-RTA-DS" &&
        removeDeleteIdentifier === "transfer"
      ) {
        data = {
          user_role: "BCHead",
          request_id: request_type.activeId,
          approval_flag: "R",
          created_by: newUserData?.bc_head_pers_no,
          bc_head_remark: bcRemark,
        };
      }
      console.log("Data from BcHead Approval -> ", data);
      try {
        const response = await apiService.Additionalaccessapprovalreject(data, dispatchNew)
        dispatchNew(setLogin({...auth, recentStatus: response.status}))
          showPopup({
            type: MESSAGE_TYPE.SUCCESS,
            contextText: MESSAGE_TYPE.SUCCESS,
            info: "Request Approved for : " + request_type.activeId,
            reloads:true,
          });
          history.push("/requestor-dashboard");
      } catch (error) {
        dispatchNew(setLogin({ ...auth, recentStatus: error.response.status }));
      }      
    }
  };

  const SAApproval = async() => {
    let data = {};
    if (accessRole.includes("SA")) {
      if (request_type.requestType === "AA-NA-SUP") {
        data = {
          user_role: "SuperAdmin",
          request_id_param: request_type.activeId,
          approval_flag: "A",
          user_id_param: personNumber,
          sa_remark_param: SARemark,
        };
      }
      if (
        request_type.requestType === "AA-RTA-SUP" &&
        removeDeleteIdentifier === "remove"
      ) {
        data = {
          user_role: "SuperAdmin",
          request_id_param: request_type.activeId,
          approval_flag: "A",
          user_id_param: personNumber,
          sa_remark_param: SARemark,
        };
      }
      if (
        request_type.requestType === "AA-RTA-SUP" &&
        removeDeleteIdentifier === "transfer"
      ) {
        data = {
          user_role: "SuperAdmin",
          request_id_param: request_type.activeId,
          approval_flag: "A",
          user_id_param: personNumber,
          sa_remark_param: SARemark,
        };
      }
      if (request_type.requestType === "AA-NA-DS") {
        data = {
          user_role: "SuperAdmin",
          request_id_param: request_type.activeId,
          approval_flag: "A",
          user_id_param: personNumber,
          sa_remark_param: SARemark,
        };
      }
      if (
        request_type.requestType === "AA-RTA-DS" &&
        removeDeleteIdentifier === "remove"
      ) {
        data = {
          user_role: "SuperAdmin",
          request_id_param: request_type.activeId,
          approval_flag: "A",
          user_id_param: personNumber,
          sa_remark_param: SARemark,
        };
      }
      if (
        request_type.requestType === "AA-RTA-DS" &&
        removeDeleteIdentifier === "transfer"
      ) {
        data = {
          user_role: "SuperAdmin",
          request_id_param: request_type.activeId,
          approval_flag: "A",
          user_id_param: personNumber,
          sa_remark_param: SARemark,
        };
      }
      console.log("Data from BcHead Approval -> ", data);
      try {
        const response = await apiService.AdditionalAccessApprovalRejectAdmin(data, dispatchNew)
        dispatchNew(setLogin({...auth, recentStatus: response.status}))      
          showPopup({
            type: MESSAGE_TYPE.SUCCESS,
            contextText: MESSAGE_TYPE.SUCCESS,
            info: "Request Approved for : " + request_type.activeId,
            reloads:true,
          });
          history.push("/requestor-dashboard");
      } catch (error) {
        dispatchNew(setLogin({ ...auth, recentStatus: error.response.status }));
      }
    }
  };

  const SAReject = async() => {
    let data = {};
    if (accessRole.includes("SA")) {
      if (request_type.requestType === "AA-NA-SUP") {
        data = {
          user_role: "SuperAdmin",
          request_id_param: request_type.activeId,
          approval_flag: "R",
          user_id_param: personNumber,
          sa_remark_param: SARemark,
        };
      }
      if (
        request_type.requestType === "AA-RTA-SUP" &&
        removeDeleteIdentifier === "remove"
      ) {
        data = {
          user_role: "SuperAdmin",
          request_id_param: request_type.activeId,
          approval_flag: "R",
          user_id_param: personNumber,
          sa_remark_param: SARemark,
        };
      }
      if (
        request_type.requestType === "AA-RTA-SUP" &&
        removeDeleteIdentifier === "transfer"
      ) {
        data = {
          user_role: "SuperAdmin",
          request_id_param: request_type.activeId,
          approval_flag: "R",
          user_id_param: personNumber,
          sa_remark_param: SARemark,
        };
      }
      if (request_type.requestType === "AA-NA-DS") {
        data = {
          user_role: "SuperAdmin",
          request_id_param: request_type.activeId,
          approval_flag: "R",
          user_id_param: personNumber,
          sa_remark_param: SARemark,
        };
      }
      if (
        request_type.requestType === "AA-RTA-DS" &&
        removeDeleteIdentifier === "remove"
      ) {
        data = {
          user_role: "SuperAdmin",
          request_id_param: request_type.activeId,
          approval_flag: "R",
          user_id_param: personNumber,
          sa_remark_param: SARemark,
        };
      }
      if (
        request_type.requestType === "AA-RTA-DS" &&
        removeDeleteIdentifier === "transfer"
      ) {
        data = {
          user_role: "SuperAdmin",
          request_id_param: request_type.activeId,
          approval_flag: "R",
          user_id_param: personNumber,
          sa_remark_param: SARemark,
        };
      }
      console.log("Data from BcHead Approval -> ", data);
      try {
        const response = await apiService.AdditionalAccessApprovalRejectAdmin(data,dispatchNew)
        dispatchNew(setLogin({...auth, recentStatus: response.status}))
        showPopup({
          type: MESSAGE_TYPE.SUCCESS,
          contextText: MESSAGE_TYPE.SUCCESS,
          info: "Request Rejected for : " + request_type.activeId,
          reloads:true,
        });
        history.push("/requestor-dashboard");
      } catch (error) {
        dispatchNew(setLogin({ ...auth, recentStatus: error.response.status }));
      }     
    }
  };

  const handleApproval = () => {
    if (accessRole.includes("B")) {
      bcHeadApproval();
    } else if (accessRole.includes("SA")) {
      SAApproval();
    }
  };

  const handleRejection = () => {
    if (accessRole.includes("B")) {
      bcHeadReject();
    } else if (accessRole.includes("SA")) {
      SAReject();
    }
  };

  const [emp_app_details, setEmp_app_details] = useState([]);
  const [emp_app_details_status, setEmp_app_details_status] = useState();
  const [tableData, setTableData] = useState([]);
  const [asnCount, setAsnCount] = useState(0);
  const [process, setProcess] = useState("");
  const [newAccess, setNewAccess] = useState("");
  const [transferAccess, setTransferAccess] = useState("");
  const [requestType, setRequestType] = useState("");
  const [companyCodeOption, setCompanyCode] = useState([]);

  useEffect(() => {
    console.log("Value of Dropdown -> ", dropDownValue);
    setEmp_app_details([]);
    setCurrentUserData([]);
    setCurrentTicket("");
    setNewUserData({});
    setNewAccessTicket("");
    setEmp_app_details_status();
    setEDetails("");
  }, [requestType, dropDownValue.value]);

  const [myState, setState] = React.useState({
    poNo: "",
    stmNo: "",
    chassisNo: null,
    toDate: null,
    fromDate: null,
    bodyBuilder: null,
    checkFlag: false,
    checkBox: true,
  });

  const [selectedBC, setSelectedBC] = useState([]);
  const [accessRole, setUserRole] = useState(userRole);

  useEffect(()=>{
    setCurrentTicket(personNumber)
  },[personNumber])

  const onChangeHandler = (event) => {
    const inputValue = event.target.value.trim();
    if (/^\d*$/.test(inputValue)) {
    setEDetails(inputValue);
    }
  };
  const onNewAccessTicket = (event) => {
    const inputValue = event.target.value.trim();
    if(inputValue.length === 6 || inputValue?.length === 8){
      if (/^\d*$/.test(inputValue)) {
        setNewAccessTicket(inputValue);
      }
      else if((inputFields.length === 6 || inputFields.length === 8) && inputFields.length >1){
        setNewAccessTicket("")
      }
    } 
  
  };
  const onCurrentTicket = (event) => {
    const inputValue = event.target.value.trim();
    if (/^\d*$/.test(inputValue)) {
      setCurrentTicket(inputValue);
    }
  };


  useEffect(() => {
    console.log(
      "Checking the user role and assigning the eDetails",
      personNumber,
      hasSARole
    );
    if (hasSARole === false) {
      console.log("Inside the setting useState block");
      if (request_type.requestType === undefined) {
        if (dropDownValue.value === "SUP" && requestType === "NA") {
          setDisableTicketNumber(true);
          setEDetails(personNumber);
        } else if (dropDownValue.value === "SUP" && requestType === "RTA") {
          setDisableTicketNumber(true);
          setCurrentTicket(personNumber);
        } else if (dropDownValue.value === "DS" && requestType === "NA") {
          setDisableTicketNumber(true);
          setEDetails(personNumber);
        } else if (dropDownValue.value === "DS" && requestType === "RTA") {
          setDisableTicketNumber(true);
          setCurrentTicket(personNumber);
        }
      }
    }
  }, [dropDownValue.value, requestType,personNumber]);

  useEffect(() => {
    console.log("Value set for eDetails -> ", eDetails);
  }, [eDetails]);


  useEffect(() => {
    if (accessRole.includes("SA")) {
      setBCHeadDisable(true);
    }
  }, [accessRole]);

  const strflag = () => {
    var regexp = new RegExp(/^[a-zA-Z0-9 ]+$/);
    let str = myState.chassisNo;
    if (myState.chassisNo == "") {
      return;
    }

    if (regexp.test(str)) {
      setState((prevData) => ({ ...prevData, chassisNoFlagStr: false }));
      return true;
    } else {
      setState((prevData) => ({ ...prevData, chassisNoFlagStr: true }));
      return false;
    }
  };
  const BG_COLOR = "#fffef8";
  const [backgroundColors, setBackgroundColors] = useState({
    processInfoBg: true,
    supplierInfoBg: false,
    poInfoBg: false,
    projectsInfoBg: false,
  });
  const { processInfoBg, supplierInfoBg, poInfoBg, projectsInfoBg } =
    backgroundColors;

  const changeBackgroundColor = (field) =>
    setBackgroundColors((prev) => {
      const newBackgroundColors = {};
      // eslint-disable-next-line no-restricted-syntax
      for (const [key, value] of Object.entries(prev)) {
        if (key === field) newBackgroundColors[key] = true;
        else newBackgroundColors[key] = false;
      }
      return newBackgroundColors;
    });

  const handleClose = () => setIsPopupOpen(false);

  const handleClose2 = () => setConfirmModal2(false);
  const resetFields = () => {
    if (myState.checkFlag == true) {
      setState((prevData) => ({
        ...prevData,
        chassisNo: null,
        toDate: null,
        fromDate: null,
      }));
    } else {
      setState((prevData) => ({
        ...prevData,
        chassisNo: null,
        toDate: null,
        fromDate: null,
        bodyBuilder: null,
      }));
    }

    setTableData([]);
    setHighlightMandatoryFields(false);
  };

  const renderSpocApproval = () => (
    <div className={styles.formGroup}>
      <Grid container spacing={1} style={{ marginTop: "10px" }} columns={12}>
        <Grid item md={2} lg={2} xs={2}>
          <div className={styles.rowDiv}>
            <div className={styles.lableDiv2}>
              <label>Approval Details</label>
            </div>
          </div>
        </Grid>
        <Grid item md={10} lg={10} xs={10}>
          <TableSimple
            tableColumnData={selectedBCInfo?.map((info, index) => ({
              bcDetails: info.bc_details,
              department_head: info.department_head,
              // requestId: requestNumber[index] || "N/A",
            }))}
            tableHeaderLabel={["BC Details", "Department Head"]}
            TableRowHederAling="start"
            size="small"
            headerColor="#E6F2FF"
            className="custom-table"
          />
        </Grid>
      </Grid>
    </div>
  );

  const renderDetails = () => (
    <div className={styles.formGroup}>
      <Grid container spacing={1} style={{ marginTop: "10px" }} columns={12}>
        <Grid item md={2} lg={2} xs={2}>
          <div className={styles.rowDiv}>
            <div className={styles.lableDiv2}>
              <label>Approval Details</label>
            </div>
          </div>
        </Grid>
        <Grid item md={10} lg={10} xs={10}>
          <TableSimple
            tableColumnData={[
              {
                ticket: emp_app_details[0]?.bc_head_pers_no || "",
                empName: emp_app_details[0]?.bc_head_name || "",
                bcNo: emp_app_details[0]?.bc_no || "",
                bcDesc: emp_app_details[0]?.costcenter_name || "",
                workArea: emp_app_details[0]?.workarea || "",
              },
            ]}
            tableHeaderLabel={[
              "Ticket No_50",
              "Employee Name_150",
              "BC No._60",
              "BC Description_150",
              "Work Area_100",
            ]}
            TableRowHederAling="start"
            size="small"
            headerColor="#E6F2FF"
            className="custom-table"
          />
        </Grid>
      </Grid>
    </div>
  );

  const renderApprovalDetailsDelete = () => (
    <div className={styles.formGroup}>
      <Grid container spacing={1} style={{ marginTop: "10px" }} columns={12}>
        <Grid item md={2} lg={2} xs={2}>
          <div className={styles.rowDiv}>
            <div className={styles.lableDiv2}>
              <label>Approval Details</label>
            </div>
          </div>
        </Grid>
        <Grid item md={10} lg={10} xs={10}>
          <TableSimple
            tableColumnData={[
              {
                ticket:
                  currentTicket !== "" && newAccessTicket === ""
                    ? currentUserData[0]?.bc_head_persno || ""
                    : newUserData?.bc_head_persno || "",
                empName:
                  currentTicket !== "" && newAccessTicket === ""
                    ? currentUserData[0]?.bchead_name || ""
                    : newUserData?.bchead_name || "",
                bcNo:
                  currentTicket !== "" && newAccessTicket === ""
                    ? currentUserData[0]?.bc_no || ""
                    : newUserData?.bc_no || "",
                bcDesc:
                  currentTicket !== "" && newAccessTicket === ""
                    ? currentUserData[0]?.costcenter_name || ""
                    : newUserData?.costcenter_name || "",
                workArea:
                  currentTicket !== "" && newAccessTicket === ""
                    ? currentUserData[0]?.workarea || ""
                    : newUserData?.workarea || "",
              },
            ]}
            tableHeaderLabel={[
              "Ticket No_50",
              "Employee Name_150",
              "BC No._60",
              "BC Description_150",
              "Work Area_100",
            ]}
            TableRowHederAling="start"
            size="small"
            headerColor="#E6F2FF"
            className="custom-table"
          />
        </Grid>
      </Grid>
    </div>
  );

  const renderApprovalDetails = () => (
    <div className={styles.formGroup}>
      <Grid container spacing={1} style={{ marginTop: "10px" }} columns={12}>
        <Grid item md={2} lg={2} xs={2}>
          <div className={styles.rowDiv}>
            <div className={styles.lableDiv2}>
              <label>Approval Details</label>
            </div>
          </div>
        </Grid>
        <Grid item md={10} lg={10} xs={10}>
          <TableSimple
            tableColumnData={[
              {
                ticket: newUserData.bc_head_persno ?? "",
                empName: newUserData.bchead_name || "",
                bcNo: newUserData.bc_no || "",
                bcDesc: newUserData.costcenter_name || "",
                workArea: newUserData.workarea || "",
              },
            ]}
            tableHeaderLabel={[
              "Ticket No_85",
              "Employee Name_100",
              "BC No._60",
              "BC Description_100",
              "Work Area_100",
            ]}
            TableRowHederAling="start"
            size="small"
            headerColor="#E6F2FF"
            className="custom-table"
          />
        </Grid>
      </Grid>
    </div>
  );

  const renderSPOCDetails = () => (
    <div className={styles.formGroup}>
      <Grid
        container
        spacing={1}
        className={styles.myGrid}
        style={{ marginTop: "10px" }}
        columns={12}
      >
        <Grid item md={12} lg={12} xs={12}>
          <TableSimple
            tableColumnData={[
              {
                project_no: "2343",
                project_name: "YODHA CNG",
                ticket_no: "351243",
                spoc_name: "Sandeep Kumar Ghosh",
                status: "Open",               
              },
            ]}
            tableHeaderLabel={[
              "Project No",
              "Project Name",
              "SPOC Ticket No",
              "SPOC Name",
              "Status",
            ]}
            TableRowHederAling="start"
            size="small"
            headerColor="#2C73D2"
            className="custom-table"
          />
        </Grid>
      </Grid>
    </div>
  );

  const renderroledetails = () => (

    <div
      className={styles.formGroup}
      // style={{ backgroundColor: processInfoBg ? BG_COLOR : null }}
      onClick={() => changeBackgroundColor("processInfoBg")}
    >
      <Grid container spacing={1} className={styles.myGrid} columns={12} style={{marginTop:'10px'}}>
        <Grid item md={3} lg={3}>
          <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv2)}>
              <label className={styles.spanClass}>Role</label>
            </div>
            <div className={styles.formDiv}>
              <CustomSelect    
                isDisabled={disable}
                className={clsx(styles.select, styles.sel2)}
                isMulti={false}
                // isClearable
                options={role}
                value={dropDownValue}
                onChange={(e) => {
                  setDropDownValue(e);
                  setOnChange(true);
                  setDisableButton(false)
                  setNewAccessTicket("")
                  setSelectedBC([])
                  setError('')
                  // const isTypeSelected = !!selectedOption;
                }}
                name="type"
              />
            </div>
          </div>
          {error && <p style={{ color: 'red', fontSize: '14px', margin: '6px 0px 0px 70px'}}>{error}</p>}
          {myState.handoverDateFlag && (
            // <div style={{ "display": "block" }}  className={styles.invalidfeedback}>Reported date should not be less than invoice date</div>
            <div style={{ marginLeft: "35px" }} className={styles.error}>
              Inserted On is mandatory field
            </div>
          )}
        </Grid>

        <Grid item md={6} lg={6} sm={2}>
          <div className={styles.rowDiv}>
            <div className={styles.formDiv_radio}>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                markIfUnselected={highlightMandatoryFields}
                resetAllVisitedFields={resetAllVisitedFields}
                style={{
                  marginLeft: "15px",
                }}
                value={requestType}
                // onChange={(e) => setRequestType(e.target.value)}
                onChange={handleSelectChange}
                defaultValue=""
                // onClick={(e) => handleViewbtn(e.target.value)}
              >
                <FormControlLabel
                  value="NA"
                  name="New Access"
                  control={<Radio size="small" disabled={disable} />}
                  label="New Access"
                  // style={{ color: "black" }}
                  className={styles.radiobtn}
                />
              </RadioGroup>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                markIfUnselected={highlightMandatoryFields}
                resetAllVisitedFields={resetAllVisitedFields}
                value={requestType}
                // onChange={(e) => setRequestType(e.target.value)}
                onChange={handleSelectChange}
                defaultValue=""
              >
                <FormControlLabel
                  value="RTA"
                  name="Transfer Access"
                  control={<Radio size="small" disabled={disable} />}
                  label="Transfer Access / Delete Access"
                  style={{ color: "black" }}
                  className={styles.radiobtn}
                />
              </RadioGroup>
            </div>
          </div>
        </Grid>

        {requestId !== "" && dropDownValue.value === "SUP" && (
          <Grid item md={4} lg={4}>
            <div className={styles.rowDiv}>
              <div className={clsx(styles.lableDiv)}>
                <label className={styles.spanClass}>
                  Request Id : {requestId}
                </label>
              </div>
            </div>
          </Grid>
        )}
      </Grid>
    </div>
  );


  useEffect(() => {
    console.log("Current user Data -> ", currentUserData);
    console.log("New User Data -> ", newUserData);
    console.log("Exisitng BC List -> ", existingBC);
  }, [currentUserData, newUserData, existingBC]);

  const RTA = async() => {
    setLoadingTruck(false)
    let data = {};
    if (currentTicket != "" && newAccessTicket === "") {
      console.log("Delete Supervisor Case");
      data = {
        pers_no: sanitizeNumeric(currentTicket),
        trans_pers_no: null,
        operation_flag: "AA",
        suboperation_flag: requestType,
        erole: dropDownValue.value,
      };
      // currentTicket.length == 6
      if (searchByCurrentTicket) {
        try {
          const response = await apiService.AccessControlSupInfo(data, dispatchNew)
          dispatchNew(setLogin({...auth, recentStatus: response.status}))
          setEmp_app_details_status(response?.msg);
          let lowercaseMsg = response?.msg.toLowerCase();
          
          if (lowercaseMsg === "fail") {
            setLoadingTruck(false)
            showPopup({
              type: MESSAGE_TYPE.INFORMATION,
              contextText: MESSAGE_TYPE.INFORMATION,
              info: response?.data,
              reloads:true,
            });

          } else {
            if (dropDownValue.value === "SUP") {
              if(lowercaseMsg==='success') {
                setLoadingTruck(false)           

            let noBCHeadTrans=false
             let noBcHeadNameTrans=false
             if(response?.data){ 
              noBCHeadTrans =response?.data[0]?.bc_head_persno==null
              noBcHeadNameTrans=response?.data[0]?.bchead_name==null
             }
            
             if(noBCHeadTrans  || noBcHeadNameTrans){
              setLoadingTruck(false)
              showPopup({
                type: MESSAGE_TYPE.INFORMATION,
                 contextText: MESSAGE_TYPE.INFORMATION,
                 info: 'No Approving Authority request you to contact SBP team',
               });
               setDisableButton(true)
               setCurrentUserData(response?.data)
             }
            else{
              setCurrentUserData(response?.data)
            }
            }}
            if (dropDownValue.value === "DS") {
              if(lowercaseMsg==='success') {
                setLoadingTruck(false)
              
              console.log(
                "Data from RTA for DS -> ",
                response?.data.emp_details
              );
              setCurrentUserData(response?.data?.emp_details);
              setBCDetails(response?.data?.bc_details);
              const bcList = response?.data?.bc_details;
              const transformedData = bcList.map((item) => ({
                value: item.bc_number,
                label: item.bc_details,
              }));
              setExistingBC(transformedData);
            }
          }}
        } catch (error) {
           dispatchNew(setLogin({ ...auth, recentStatus: error.response.status }));
           if (error.response && error.response.status === 403) {
             console.error("Forbidden (403) error occurred. You may not have permission for this operation.");           
           } 
        }      
      }
    } else {
      data = {
        pers_no: sanitizeNumeric(currentTicket),
        trans_pers_no: sanitizeNumeric(newAccessTicket),
        operation_flag: "AA",
        suboperation_flag: requestType,
        erole: dropDownValue.value,
      };
      // newAccessTicket.length == 6 && currentTicket.length == 6
      if (searchByNewTicket && searchByCurrentTicket) {
        try {
          const response = await apiService.AccessControlSupInfo(data, dispatchNew)
          dispatchNew(setLogin({...auth, recentStatus: response.status}))           
            setEmp_app_details_status(response?.msg);       
            let lowercaseMsg = response?.msg.toLowerCase();            
            if (lowercaseMsg === "fail") {
              setLoadingTruck(false)
              showPopup({
                type: MESSAGE_TYPE.INFORMATION,
                contextText: MESSAGE_TYPE.INFORMATION,
                info: response?.data,
                reloads:true,
              });
              setCurrentUserData([])
              setNewUserData([])
              setExistingBC([])
            }
                        
            else {
                if (dropDownValue.value === "SUP") {
                  if(lowercaseMsg==='success') {
                    setLoadingTruck(false)                 
                  const apiData = response?.data;
                  let noBCHeadTrans=false
                  let noBcHeadNameTrans=false
                  if(response?.data){ 
                    const apiDataSup=response?.data;
                    const currentUserSup = apiDataSup.find(
                      (item) => item.pers_no === newAccessTicket
                    );
                   noBCHeadTrans =currentUserSup?.bc_head_persno==null
                   noBcHeadNameTrans=currentUserSup?.bchead_name==null

                   if(noBCHeadTrans  || noBcHeadNameTrans){
                    setLoadingTruck(false)
                    showPopup({
                      type: MESSAGE_TYPE.INFORMATION,
                       contextText: MESSAGE_TYPE.INFORMATION,
                       info: 'No Approving Authority request you to contact SBP team',
                       reloads:true,
                     });
                     setDisableButton(true)
                   }
                  }
                  const currentUser = apiData.find(
                    (item) => item.pers_no === currentTicket
                  );
                  const newUser = apiData.find(
                    (item) => item.pers_no === newAccessTicket
                  );               
                  setCurrentUserData(currentUser);
                  setNewUserData(newUser);
                  if(currentUser?.location !== newUser?.location){
                    showPopup({
                      type: MESSAGE_TYPE.INFORMATION,
                      contextText: MESSAGE_TYPE.INFORMATION,         
                      info: "Proposed ticket number is from different location",
                      reloads:true,
                    });
                  }
                }}
                if (dropDownValue.value === "DS") {
                  if(lowercaseMsg==='success') {
                    setLoadingTruck(false)
                    let noBCHeadTrans=false
                    let noBcHeadNameTrans=false
                    if(response?.data){ 
                      const apiDataDs = response?.data?.emp_details;
                      const newUser = apiDataDs.find(
                        (item) => item.pers_no === newAccessTicket
                      );
                     noBCHeadTrans =newUser?.bc_head_pers_no==null
                     noBcHeadNameTrans=newUser?.bc_head_name==null
                      setLoadingTruck(false)
                     
                    }
                  
                  const transformedData = Object.values(
                    response?.data?.bc_details
                  ).map((item) => ({
                    value: item.bc_number,
                    label: item.bc_details,
                  }));
                  setExistingBC(transformedData);
                  const apiData = response?.data?.emp_details;
                  const currentUser = apiData.find(
                    (item) => item.pers_no === currentTicket
                  );
                  const newUser = apiData.find(
                    (item) => item.pers_no === newAccessTicket
                  );                 
                  setCurrentUserData(currentUser);
                  setNewUserData(newUser);
                }
              }}
        } catch (error) {
          dispatchNew(setLogin({ ...auth, recentStatus: error.response.status }));
        }
   
      }
    }
  };

  useEffect(() => {
    RTA();
  }, [ searchByCurrentTicket,searchByNewTicket]);


  const renderOther1 = () => (
    <div className={styles.formGroup}>
      <Grid container spacing={1} style={{ marginTop: "10px" }} columns={12}>
        <Grid item md={2} lg={2} xs={2}>
          <div className={styles.rowDiv}>
            <div className={styles.lableDiv2}>
              <label>Employee Details</label>
            </div>
          </div>
        </Grid>
        <Grid item md={10} lg={10} xs={10}>
          <TableSimple
            tableColumnData={[
              {
                type: "Current",
                ticket: (
                  <ValidatingTextField
                    variant="outlined"
                    size="small"
                    isDisabled={disableTicketNumber}
                    value={currentTicket}
                    // onChange={(e) => setCurrentTicket(e.target.value)}
                    onChange={onCurrentTicket}

                    name="Ticket Number"
                    inputProps={{
                      "data-testid": "remark-input",
                    }}
                    style={{ width: "100%" }}
                  />
                ),
                empName:  
                  currentTicket !== "" && newAccessTicket === ""
                    ? currentUserData[0]?.employee_name || ""
                    : currentUserData?.employee_name || "",
                bcNo:
                  currentTicket !== "" && newAccessTicket === ""
                    ? currentUserData[0]?.bc_no || ""
                    : currentUserData?.bc_no || "",
                bcDesc:
                  currentTicket !== "" && newAccessTicket === ""
                    ? currentUserData[0]?.costcenter_name || ""
                    : currentUserData?.costcenter_name || "",
                workArea:
                  currentTicket !== "" && newAccessTicket === ""
                    ? currentUserData[0]?.workarea || ""
                    : currentUserData?.workarea || "",
              },
              {
                type: "Propose",
                ticket: (
                  <ValidatingTextField
                    variant="outlined"
                    size="small"
                    //  value={newAccessTicket}
                    // onChange={(e) => setNewAccessTicket(e.target.value)}
                  onChange={onNewAccessTicket}

                    name="Ticket Number" 
                    inputProps={{
                      "data-testid": "remark-input",
                    }}
                    style={{ width: "100%" }}
                  />
                ),
                empName: newUserData.employee_name ?? "",
                bcNo: newUserData.bc_no ?? "",
                bcDesc: newUserData.costcenter_name ?? "",
                workArea: newUserData.workarea ?? "",
              },
            ]}
            tableHeaderLabel={[
              "_30 ",
              "Ticket No_50",
              "Employee Name_100",
              "BC No._60",
              "BC Description_100",
              "Work Area_100",
            ]}
            TableRowHederAling="start"
            size="small"
            headerColor="#E6F2FF"
            className="custom-table"
          />
        </Grid>
      </Grid>
    </div>
  );

  const renderBCDetails = () => (
    <div
      className={styles.formGroup}
      // style={{ backgroundColor: processInfoBg ? BG_COLOR : null }}
      onClick={() => changeBackgroundColor("processInfoBg")}
    >
      <Grid
        container
        spacing={1}
        className={styles.myGrid}
        style={{ marginTop: "10px" }}
        columns={12}
      >
        <Grid item md={4} lg={4}>
          <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv)}>
              <span>Work Area</span>
            </div>
            <div className={styles.formDiv}>
              <CustomSelect
                isMulti={true}
                isMandatory
                className={clsx(styles.select, styles.sel2)}
                isClearable
                options={type.Work_Area}
                value={selectedData.Work_Area}
                onChange={(e) => {
                  // setDropDownValue(e);
                  setSelectedData({ ...selectedData, Work_Area: e });
                  setOnChange(true);
                  // const isTypeSelected = !!selectedOption;
                }}
              />
            </div>
          </div>

          {myState.handoverDateFlag && (
            // <div style={{ "display": "block" }}  className={styles.invalidfeedback}>Reported date should not be less than invoice date</div>
            <div style={{ marginLeft: "35px" }} className={styles.error}>
              Inserted On is mandatory field
            </div>
          )}
        </Grid>

        <Grid item md={4} lg={4}>
          <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv)}>
              <span>Location</span>
            </div>
            <div className={styles.formDiv}>
              <CustomSelect
                isMulti={true}
                isMandatory
                className={clsx(styles.select, styles.sel2)}
                isClearable
                options={type.Location}
                value={selectedData.Location}
                onChange={(e) => {
                  // setDropDownValue(e);
                  setSelectedData({ ...selectedData, Location: e });
                  setOnChange(true);
                  // const isTypeSelected = !!selectedOption;
                }}
              />
            </div>
          </div>

          {myState.handoverDateFlag && (
            // <div style={{ "display": "block" }}  className={styles.invalidfeedback}>Reported date should not be less than invoice date</div>
            <div style={{ marginLeft: "35px" }} className={styles.error}>
              Inserted On is mandatory field
            </div>
          )}
        </Grid>
      </Grid>

      <Grid
        container
        spacing={1}
        className={styles.myGrid}
        style={{ marginTop: "10px" }}
        columns={12}
      >
        <Grid item md={4} lg={4}>
          <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv)}>
              <span>Pune</span>
            </div>
            <div className={styles.formDiv}>
              <CustomSelect
                isMulti={true}
                isMandatory
                className={clsx(styles.select, styles.sel2)}
                isClearable
                options={type.Pune}
                value={selectedData.Pune}
                onChange={(e) => {
                  // setDropDownValue(e);
                  setSelectedData({ ...selectedData, Pune: e });
                  setOnChange(true);
                  // const isTypeSelected = !!selectedOption;
                }}
              />
            </div>
          </div>

          {myState.handoverDateFlag && (
            // <div style={{ "display": "block" }}  className={styles.invalidfeedback}>Reported date should not be less than invoice date</div>
            <div style={{ marginLeft: "35px" }} className={styles.error}>
              Inserted On is mandatory field
            </div>
          )}
        </Grid>

        <Grid item md={4} lg={4}>
          <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv)}>
              <span>Jamshedpur</span>
            </div>
            <div className={styles.formDiv}>
              <CustomSelect
                isMulti={true}
                isMandatory
                className={clsx(styles.select, styles.sel2)}
                isClearable
                options={type.Jamshedpur}
                value={selectedData.Jamshedpur}
                onChange={(e) => {
                  // setDropDownValue(e);
                  setSelectedData({ ...selectedData, Jamshedpur: e });
                  setOnChange(true);
                  // const isTypeSelected = !!selectedOption;
                }}
              />
            </div>
          </div>

          {myState.handoverDateFlag && (
            // <div style={{ "display": "block" }}  className={styles.invalidfeedback}>Reported date should not be less than invoice date</div>
            <div style={{ marginLeft: "35px" }} className={styles.error}>
              Inserted On is mandatory field
            </div>
          )}
        </Grid>

        <Grid item md={4} lg={4}>
          <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv)}>
              <span>Lucknow</span>
            </div>
            <div className={styles.formDiv}>
              <CustomSelect
                isMulti={true}
                isMandatory
                className={clsx(styles.select, styles.sel2)}
                isClearable
                options={type.Lucknow}
                value={selectedData.Lucknow}
                onChange={(e) => {
                  // setDropDownValue(e);
                  setSelectedData({ ...selectedData, Lucknow: e });
                  setOnChange(true);
                  // const isTypeSelected = !!selectedOption;
                }}
              />
            </div>
          </div>

          {myState.handoverDateFlag && (
            // <div style={{ "display": "block" }}  className={styles.invalidfeedback}>Reported date should not be less than invoice date</div>
            <div style={{ marginLeft: "35px" }} className={styles.error}>
              Inserted On is mandatory field
            </div>
          )}
        </Grid>
      </Grid>
    </div>
  );

  const renderBCDetailsRTA = () => (
    <div
      className={styles.formGroup}
      // style={{ backgroundColor: processInfoBg ? BG_COLOR : null }}
      onClick={() => changeBackgroundColor("processInfoBg")}
    >
      <Grid
        container
        spacing={1}
        className={styles.myGrid}
        style={{ marginTop: "10px" }}
        columns={12}
      >
        <Grid item md={4} lg={4}>
          <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv)}>
              <span>Tagged BCs</span>
            </div>
            <div className={styles.formDiv}>
              <CustomSelect
                isMandatory
                className={clsx(styles.select, styles.sel2)}
                isMulti={true}
                isClearable
                options={existingBC}
                name="wa"
                value={selectedBC}
                onChange={(selectedOption) => {
                  setSelectedBC(selectedOption);
                }}
              />
            </div>
          </div>

          {myState.handoverDateFlag && (
            // <div style={{ "display": "block" }}  className={styles.invalidfeedback}>Reported date should not be less than invoice date</div>
            <div style={{ marginLeft: "35px" }} className={styles.error}>
              Inserted On is mandatory field
            </div>
          )}
        </Grid>
      </Grid>
    </div>
  );

  useEffect(() => {
    console.log("Seelcted BC -> ", selectedBC);
  }, [selectedBC]);

  const renderBCDetails1 = () => (
    <div className={styles.formGroup}>

      <Grid container spacing={1} style={{ marginTop: "10px" }} columns={12}>
        <Grid item md={2} lg={2} xs={2}>
          <div className={styles.rowDiv}>
            <div className={styles.lableDiv2}>
              <label>BC List</label>
            </div>
          </div>
        </Grid>
        <Grid item md={10} lg={10} xs={10}>
          <MultiSelects
            value={selectedBC}
            isMandatory
            className={clsx(styles.select, styles.sel2)}
            isMulti
            isClearable
            options={existingBC}
            name="city"
            onChange={(selectedOption) => {          
              handleBcChange(selectedOption)
            }}
          />
        </Grid>       
      </Grid>
    </div>
  );
  const baseURL = useSelector((state) => state.counter.baseUrl);

  const accessControlSupInfo = async() => {
    setLoadingTruck(true)
    if (dropDownValue.value === "SUP") {
      // eDetails.length === 6
      if (searchByTicket) {
        const data = {
          pers_no: sanitizeNumeric(eDetails),
          trans_pers_no: "",
          operation_flag: "AA",
          suboperation_flag: requestType,
          erole: dropDownValue.value,
        };
        try {
          const response = await apiService.AccessControlSupInfo(data, dispatchNew)
          dispatchNew(setLogin({...auth, recentStatus: response.status}))
            let lowercaseMsg = response?.msg.toLowerCase();
            if (lowercaseMsg === "fail") {
              setLoadingTruck(false)
              showPopup({
                type: MESSAGE_TYPE.INFORMATION,
                contextText: MESSAGE_TYPE.INFORMATION,
                info: response?.data,
                reloads:true,
              });
            } else {
              if(lowercaseMsg === "success"){
                setLoadingTruck(false)
              }          
              let noBCHead=false
              let noBcHeadName=false
              if(response?.data){ 
                noBCHead =response?.data[0]?.bc_head_pers_no==null
                noBcHeadName=response?.data[0]?.bc_head_name==null
              }
              
              if(noBCHead || noBcHeadName){
                setLoadingTruck(false)
                showPopup({
                  type: MESSAGE_TYPE.INFORMATION,
                  contextText: MESSAGE_TYPE.INFORMATION,
                  info: 'No Approving Authority request you to contact SBP team',
                });
                setDisableButton(true)
              setEmp_app_details(response?.data);
              setEmp_app_details_status(response?.msg);
              }
               else{
                setEmp_app_details(response?.data);
                 setEmp_app_details_status(response?.msg);
                // SetNoBcHead(false)
              }
            }
        } catch (error) {
          setLoadingTruck(false)
          console.error("Error occurred during API call: ", error);
          // console.log(error.response.status,'error.response.status')
          dispatchNew(setLogin({ ...auth, recentStatus: error.response.status }));
          // Check for 403 Forbidden status
          if (error.response && error.response?.status === 403) {
            console.error("Forbidden (403) error occurred. You may not have permission for this operation.");
            dispatchNew(setLogin({...auth, recentStatus: error.response.status}))
            return error.response.data;
          } 
        }    
      }
    }
    if (dropDownValue.value === "DS") {
      // debugger
      setLoadingTruck(true)
      // eDetails.length == 6
      if (searchByTicket) {
        const data = {
          pers_no: sanitizeNumeric(eDetails),
          trans_pers_no: null,
          operation_flag: "AA",
          suboperation_flag: requestType,
          erole: dropDownValue.value,
        };
        try {
          const response = await apiService.AccessControlSupInfo(data, dispatchNew)
          dispatchNew(setLogin({...auth, recentStatus: response.status}))
          let lowercaseMsg = response?.msg.toLowerCase();
          if (lowercaseMsg === "fail") {
            setLoadingTruck(false)
            showPopup({
              type: MESSAGE_TYPE.INFORMATION,
              contextText: MESSAGE_TYPE.INFORMATION,
              info: response?.data,
              reloads:true,
            });
          } else {
            if(lowercaseMsg === "success") {           
              setLoadingTruck(false)
            }
            setEmp_app_details(response?.data?.emp_details);
            setEmp_app_details_status(response?.msg);
            const bc = response?.data?.bc_details;
            const formattedData = bc.map((item) => ({
              value: item.bc_number,
              label: item.bc_details,
            }));
            setExistingBC(formattedData);
            setBCDetails(response?.data?.bc_details);
          }
        } catch (error) {
          setLoadingTruck(false)    
            dispatchNew(setLogin({ ...auth, recentStatus: error.response.status }));
            if (error.response && error.response?.status === 403) {
              console.error("Forbidden (403) error occurred. You may not have permission for this operation.");
              dispatchNew(setLogin({...auth, recentStatus: error.response.status}))
              return error.response.data;
            } else {
              setLoadingTruck(false)
   
            }
        } finally{
          setLoadingTruck(false)
        }
      }
    }
  };


  useEffect(() => {
    // eDetails.length === 6
    if (searchByTicket) {
      accessControlSupInfo();
    }
    else{
      setEmp_app_details('');
      setEmp_app_details_status('');

    }
    
  }, [searchByTicket]);

  useEffect(() => {
    // currentTicket.length === 6
    if (searchByCurrentTicket) {
      accessControlSupInfo();
    }
    else{
      setEmp_app_details([]);
    // setCurrentUserData({});
    // setCurrentTicket("");
    setNewUserData({});
    setNewAccessTicket("");
    setEmp_app_details_status();
    // setEDetails("");

    }
    
  }, [searchByCurrentTicket]);

  useEffect(() => {
    // newAccessTicket.length === 6
    if (searchByNewTicket) {
      accessControlSupInfo();
    }
    else{
      setEmp_app_details([]);
      // setCurrentUserData({});
      setCurrentTicket("");
      setNewUserData({});
      setNewAccessTicket("");
      setEmp_app_details_status();
      setEDetails("");
    }
    
  }, [searchByNewTicket]);

  var transformedSelectedBC = [];
  const [selectedBCInfo, setSelectedBCInfo] = useState([]);
  console.log("Selected BC by the user outside useeffect -> ", selectedBC);

  useEffect(() => {
    console.log("Selected BC by the user -> ", selectedBC);
    if (selectedBC != "") {
      transformedSelectedBC = selectedBC?.map((item) => item.value);
      console.log("transformedLocation ", transformedSelectedBC);
    
    const selectedBCInfo = transformedSelectedBC?.map((bcNumber) => {
      return BCDetails.find((bcDetail) => bcDetail.bc_number === bcNumber);
    });
    setSelectedBCInfo(selectedBCInfo);}
    else{
      setSelectedBCInfo([]);}

    }, [selectedBC]);

  useEffect(() => {
    if (selectedBCInfo.length > 0) {
      selectedBCInfo.forEach((item, index) => {
        if (item.bc_head_persno === null && item.department_head === null) {
          showPopup({
            type: MESSAGE_TYPE.INFORMATION,
             contextText: MESSAGE_TYPE.INFORMATION,
             info: `No Approving Authority for BC Number ${item.bc_number}, request you to contact SBP team`,
           });
           setSelectedBCInfo(prevState => prevState.filter((_, i) => i !== index));
           const matchingIndex = selectedBC.findIndex(bc => bc.value === item.bc_number);
           if (matchingIndex !== -1) {
            // Remove the item from selectedBC
            setSelectedBC(prevState => prevState.filter((_, i) => i !== matchingIndex));
          }
          setSelectedBCInfo(prevState => prevState.filter((_, i) => i !== index));
        }
      });
    }
  }, [selectedBCInfo]);


  const renderEmployeeDetails = () => (
    <div className={styles.formGroup}>
      <Grid
        container
        spacing={1}
        //   className={styles.myGrid}
        style={{ marginTop: "10px" }}
        columns={12}
      >
        <Grid item md={2} lg={2} xs={2} sm={2}>
          <div className={styles.rowDiv}>
            <div className={styles.lableDiv2}>
              <label>Employee Details</label>
            </div>
          </div>
        </Grid>

        <Grid item md={10} lg={10} xs={10} sm={10}>
          <TableSimple
            tableColumnData={[
              {
                ticket: (
                  <ValidatingTextField
                    variant="outlined"
                    size="small"
                    isDisabled={disableTicketNumber}
                    value={eDetails}
                    onChange={onChangeHandler}
                    name="Ticket Number"
                    inputProps={{
                      "data-testid": "remark-input",
                    }}
                    style={{ width: "100%" }}
                  />
                ),
                empName: emp_app_details[0]?.employee_name || "",
                bcNo: emp_app_details[0]?.bc_no || "",
                bcDesc: emp_app_details[0]?.costcenter_name || "",
                workArea: emp_app_details[0]?.workarea || "",
              },
            ]}
            tableHeaderLabel={[
              "Ticket No_65",
              "Employee Name_140",
              "BC No_70",
              "BC Description_160",
              "Work Area_200",
            ]}
            TableRowHederAling="start"
            size="small"
            headerColor="#E6F2FF"
            className="custom-table"
          />
        </Grid>
      </Grid>
    </div>
  );

  const renderOther = () => (
    <div
      className={styles.formGroup}
      // style={{ backgroundColor: processInfoBg ? BG_COLOR : null }}
      onClick={() => changeBackgroundColor("processInfoBg")}
    >
      <Grid
        container
        spacing={1}
        className={styles.myGrid}
        style={{ marginTop: "10px" }}
        columns={12}
      >
        <Grid item md={4} lg={4}>
          <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv)}>
              <label>Ticket Number</label>
            </div>
            <div className={styles.formDiv}>
              <ValidatingTextField
                variant="outlined"
                size="small"
                onChange={onChangeHandler}
                name="Ticket Number"
                inputProps={{
                  "data-testid": "remark-input",
                }}
                style={{ width: "100%" }}
              />
            </div>
          </div>
          {myState.handoverDateFlag && (
            <div style={{ marginLeft: "35px" }} className={styles.error}>
              Inserted On is mandatory field
            </div>
          )}
        </Grid>

        {emp_app_details_status === "Success" && (
          <Grid item md={4} lg={4}>
            <div className={styles.rowDiv}>
              <div className={clsx(styles.lableDiv)}>
                <label> Employee Name</label>
              </div>
              <div className={styles.formDiv}>
                <ValidatingTextField
                  variant="outlined"
                  size="small"
                  isDisabled={true}
                  value={emp_app_details[0]?.employee_name || ""}
                  name="projectSearch"
                  inputProps={{
                    "data-testid": "remark-input",
                  }}
                  style={{ width: "100%" }}
                />
              </div>
            </div>
            {myState.handoverDateFlag && (
              <div style={{ marginLeft: "35px" }} className={styles.error}>
                Inserted On is mandatory field
              </div>
            )}
          </Grid>
        )}
      </Grid>
      {emp_app_details_status === "Success" && (
        <Grid
          container
          spacing={1}
          className={styles.myGrid}
          style={{ marginTop: "10px" }}
          columns={12}
        >
          <Grid item md={4} lg={4}>
            <div className={styles.rowDiv}>
              <div className={clsx(styles.lableDiv)}>
                <label>BC Number</label>
              </div>
              <div className={styles.formDiv}>
                <ValidatingTextField
                  variant="outlined"
                  size="small"
                  isDisabled={true}
                  value={emp_app_details[0]?.bc_no || ""}
                  name="projectSearch"
                  inputProps={{
                    "data-testid": "remark-input",
                  }}
                  style={{ width: "80%" }}
                />
              </div>
            </div>
            {myState.handoverDateFlag && (
              <div style={{ marginLeft: "35px" }} className={styles.error}>
                Inserted On is mandatory field
              </div>
            )}
          </Grid>

          <Grid item md={4} lg={4}>
            <div className={styles.rowDiv}>
              <div className={clsx(styles.lableDiv)}>
                <label>BC Name </label>
              </div>
              <div className={styles.formDiv}>
                <ValidatingTextField
                  variant="outlined"
                  size="small"
                  isDisabled={true}
                  value={emp_app_details[0]?.costcenter_name || ""}
                  name="projectSearch"
                  inputProps={{
                    "data-testid": "remark-input",
                  }}
                  style={{ width: "100%" }}
                />
              </div>
            </div>
            {myState.handoverDateFlag && (
              <div style={{ marginLeft: "35px" }} className={styles.error}>
                Inserted On is mandatory field
              </div>
            )}
          </Grid>
        </Grid>
      )}

      {emp_app_details_status === "Success" && (
        <Grid
          container
          spacing={1}
          className={styles.myGrid}
          style={{ marginTop: "10px" }}
          columns={12}
        >
          <Grid item md={4} lg={4}>
            <div className={styles.rowDiv}>
              <div className={clsx(styles.lableDiv)}>
                <label>Work Area</label>
              </div>
              <div className={styles.formDiv}>
                <ValidatingTextField
                  variant="outlined"
                  size="small"
                  isDisabled={true}
                  value={emp_app_details[0]?.workarea || ""}
                  name="projectSearch"
                  inputProps={{
                    "data-testid": "remark-input",
                  }}
                  style={{ width: "100%" }}
                />
              </div>
            </div>
            {myState.handoverDateFlag && (
              <div style={{ marginLeft: "35px" }} className={styles.error}>
                Inserted On is mandatory field
              </div>
            )}
          </Grid>
        </Grid>
      )}
    </div>
  );

  const [requestId, setRequestId] = useState("");
  const [finalMessage, setFinalMessage] = useState("");

  const handleCancel = () => {
    window.location.reload();
  };

  const AdditionalNewAccessUserSave = async() => {
    setLoadingTruck(true)
    let data = {};
    let reqType = ""
    if (requestType === "NA" && dropDownValue.value === "SUP") {
      data = {
        ticket_no: sanitizeNumeric(eDetails),
        trans_ticket_no: null,
        bc_head: emp_app_details[0].bc_no,
        trans_bc_head: null,
        created_by: personNumber, // login userid
        request_flag: "Sup",
        request_type: "AA-NA-SUP",
        user_remark: userRemark,
        bc_details: null,
      };
      setRequestTypes( "AA-NA-SUP")
      reqType = "AA-NA-SUP"

    }

    // Remove Access
    if (
      requestType === "RTA" &&
      dropDownValue.value === "SUP" &&
      currentTicket !== "" &&
      newAccessTicket === ""
    ) {
      data = {
        ticket_no: sanitizeNumeric(currentTicket),
        trans_ticket_no: null,
        bc_head: currentUserData[0].bc_no,
        trans_bc_head: null,
        created_by: personNumber, // login userid
        request_flag: "Sup",
        request_type: "AA-RTA-SUP",
        user_remark: userRemark,
        bc_details: null,
      };
      setRequestTypes("AA-RTA-SUP")
      reqType = "AA-RTA-SUP"

    }


    if (
      requestType === "RTA" &&
      dropDownValue.value === "SUP" &&
      currentTicket !== "" &&
      newAccessTicket !== ""
    ) {
      data = {
        ticket_no: sanitizeNumeric(currentTicket),
        trans_ticket_no: newAccessTicket,
        bc_head: currentUserData.bc_no,
        trans_bc_head: newUserData.bc_no,
        created_by: personNumber, // login userid
        request_flag: "Sup",
        request_type: "AA-RTA-SUP",
        user_remark: userRemark,
        bc_details: null,
      };
      setRequestTypes("AA-RTA-SUP")
      reqType = "AA-RTA-SUP"
    }
    if (requestType === "NA" && dropDownValue.value === "DS") {
      console.log("Selected BC by User -> ", selectedBC);
      const commaSeparatedValues = selectedBC
        .map((item) => item.value.split("-")[0])
        .join(",");
      console.log("Comma Seperated -> ", commaSeparatedValues);
      data = {
        ticket_no: sanitizeNumeric(eDetails),
        trans_ticket_no: null,
        bc_head: emp_app_details[0].bc_no,
        trans_bc_head: null,
        created_by: personNumber, // login userid
        request_flag: "DS",
        request_type: "AA-NA-DS",
        user_remark: userRemark,
        bc_details: commaSeparatedValues, // add coma seperated cost center
        authorizedBCs: selectedBCInfo
      };
      setRequestTypes("AA-NA-DS")
      reqType = "AA-NA-DS"

    }


    if (
      requestType === "RTA" &&
      dropDownValue.value === "DS" &&
      currentTicket !== "" &&
      newAccessTicket === ""
    ) {
      const commaSeparatedValues = selectedBC
        .map((item) => item.value.split("-")[0])
        .join(", ");
      console.log("Comma Seperated -> ", commaSeparatedValues);
      data = {
        ticket_no: sanitizeNumeric(currentTicket),
        trans_ticket_no: null,
        bc_head: currentUserData[0].bc_no,
        trans_bc_head: null,
        created_by: personNumber, // login userid
        request_flag: "DS",
        request_type: "AA-RTA-DS",
        user_remark: userRemark,
        bc_details: commaSeparatedValues,
      };
      setRequestTypes("AA-RTA-DS")
      reqType = "AA-RTA-DS"

    }


    if (
      requestType === "RTA" &&
      dropDownValue.value === "DS" &&
      currentTicket !== "" &&
      newAccessTicket !== ""
    ) {
      // fill all
      console.log("Selected BC by User -> ", selectedBC);
      const commaSeparatedValues = selectedBC
        .map((item) => item.value.split("-")[0])
        .join(",");
      console.log("Comma Seperated -> ", commaSeparatedValues);
      data = {
        ticket_no: sanitizeNumeric(currentTicket),
        trans_ticket_no: newAccessTicket,
        bc_head: currentUserData.bc_no,
        trans_bc_head: newUserData.bc_no,
        created_by: personNumber, // login userid
        request_flag: "DS",
        request_type: "AA-RTA-DS",
        user_remark: userRemark,
        bc_details: commaSeparatedValues, // add coma seperated cost center
      };
      setRequestTypes("AA-RTA-DS")
      reqType = "AA-RTA-DS"

    }


    if (dropDownValue.value === "DS") {
      setLoadingTruck(false)
      if (selectedBC?.length === 0) {
        showPopup({
          type: MESSAGE_TYPE.INFORMATION,
          contextText: MESSAGE_TYPE.INFORMATION,
          info: "Please select at least one cost center.",
        });
      } else {
        try {
          const response = await apiService.AdditionalNewAccessUserSave(data,dispatchNew)
          const apiPayloadData = {
            user_id: personNumber,
            req_type: "created",
            request_status: null,
            start_date: "",
            end_date: "",
          };
          dispatchNew(setLogin({...auth, recentStatus: response.status, apiSendData: apiPayloadData}))
          setLoadingTruck(false)
          setRequestId(response?.data);
          let baseMessage = ""
          let inprogressData1 = response?.inprogressData
          if (response?.data !== "") {
            switch (reqType) {
                case "AA-NA-DS":
                    baseMessage = "Request for new access of Department SPOC role created";
                    break;
                case "AA-NA-SUP":
                    baseMessage = "Request for new access of Supervisor role created";
                    break;
                case "AA-RTA-DS":
                    baseMessage = newAccessTicket === "" ? "Request for delete access of Department SPOC role created" : "Request for transfer access of Department SPOC role created";
                    break;
                case "AA-RTA-SUP":
                    baseMessage = newAccessTicket === "" ? "Request for delete access of Supervisor role created" : "Request for transfer access of Supervisor role created";
                    break;
                default:
                    break;
            }
            setFinalMessage(inprogressData1 !== "" ? `${inprogressData1} and ${baseMessage}` : baseMessage);

        } else {
            setFinalMessage(inprogressData1);
        }
        } catch (error) {
          setLoadingTruck(false)
            dispatchNew(setLogin({...auth, recentStatus: error.response.status}))                 
            // Check for 403 Forbidden status
            if (error.response && error.response?.status === 403) {
              console.error("Forbidden (403) error occurred. You may not have permission for this operation.");
              // Add your specific handling logic for 403 error here in the catch block
              dispatchNew(setLogin({...auth, recentStatus: error.response.status}))
              return error.response.data;
              // For example, redirect to a login page or display an error message
            } else {
              setLoadingTruck(false)
              showPopup({
                type: MESSAGE_TYPE.INFORMATION,
                contextText: MESSAGE_TYPE.INFORMATION,
                info: "Oops! Something went wrong. Please try again later",
              });           
            }
        } finally{
          setLoadingTruck(false)
        } 
      }
    } else {  
      try {
        const response = await apiService.AdditionalNewAccessUserSave(data, dispatchNew)
        const apiPayloadData = {
          user_id: personNumber,
          req_type: "created",
          request_status: null,
          start_date: "",
          end_date: "",
        };
        dispatchNew(setLogin({...auth, recentStatus: response.status, apiSendData: apiPayloadData}))
        setLoadingTruck(false)     
        setRequestId(response?.data);
        let baseMessage = ""
          let inprogressData1 = response?.inprogressData
          if (response?.data !== "") {
            switch (reqType) {
                case "AA-NA-DS":
                    baseMessage = "Request for new access of Department SPOC role created";
                    break;
                case "AA-NA-SUP":
                    baseMessage = "Request for new access of Supervisor role created";
                    break;
                case "AA-RTA-DS":
                    baseMessage = newAccessTicket === "" ? "Request for delete access of Department SPOC role created" : "Request for transfer access of Department SPOC role created";
                    break;
                case "AA-RTA-SUP":
                    baseMessage = newAccessTicket === "" ? "Request for delete access of Supervisor role created" : "Request for transfer access of Supervisor role created";
                    break;
                default:
                    break;
            }
            setFinalMessage(inprogressData1 !== "" ? `${inprogressData1} and ${baseMessage}` : baseMessage);

        } else {
            setFinalMessage(inprogressData1);
        }
      } catch (error) {
        dispatchNew(setLogin({...auth, recentStatus: error.response.status}))
          setLoadingTruck(false)       
          // Check for 403 Forbidden status
          if (error.response && error.response?.status === 403) {
            console.error("Forbidden (403) error occurred. You may not have permission for this operation.");
            dispatchNew(setLogin({...auth, recentStatus: error.response.status}))
            return error.response.data;
          } else {
            setLoadingTruck(false)
            showPopup({
              type: MESSAGE_TYPE.INFORMATION,
              contextText: MESSAGE_TYPE.INFORMATION,
              info: "Oops! Something went wrong. Please try again later",
            });
         
          }
      } finally{
        setLoadingTruck(false)
      }   
    }
  };

  useEffect(() => {
    console.log("UserID - ", requestTypes);
    if ((finalMessage !== "" && requestId !== "") || (finalMessage !== "" && requestId === "")) {
      showPopup({
          type: MESSAGE_TYPE.SUCCESS,
          contextText: MESSAGE_TYPE.SUCCESS,
          info: finalMessage,
          dataTable: requestId.split(",")
      });
      history.push("/requestor-dashboard");
    }
  }, [finalMessage, requestId, history, requestTypes]);

  const [requestNumber, setRequestNumber] = useState([]);

  useEffect(() => {
    if (dropDownValue.value === "DS") {
      const ticketNumbers = requestId
        .split(",")
        .map((item) => item.trim().split("-")[1])
        .filter((item) => item !== undefined);
      setRequestNumber(ticketNumbers);
      console.log("Ticket NUmbers -> ", ticketNumbers);
    }
  }, [requestId]);

  const renderUserRemark = () => (
    <div className={styles.formGroup}>
      <Grid
        container
        spacing={1}
        style={{
          marginTop: "10px",
        }}
        columns={12}
      >
        <Grid item md={2} lg={2} xs={2}>
          <div className={styles.rowDiv}>
            <div className={styles.lableDiv2}>
              <label>User Remark</label>
            </div>
          </div>
        </Grid>
        <Grid item md={10} lg={10} xs={10}>
          <ValidatingTextField
            variant="outlined"
            size="small"
            isDisabled={disable}
            value={
              request_type.requestType === "AA-NA-SUP"
                ? emp_app_details[0]?.user_remark || userRemark
                : request_type.requestType === "AA-RTA-SUP"
                ? currentUserData?.user_remark || userRemark
                : request_type.requestType === "AA-NA-DS"
                ? emp_app_details[0]?.user_remark || userRemark
                : request_type.requestType === "AA-RTA-DS"
                ? currentUserData?.user_remark || userRemark
                : userRemark
            }
            onChange={(event) => {
              const newValue = event.target.value;
              if (isValidInput(newValue)|| newValue === "") {
              setUserRemark(newValue);
              }
            }}
            name="projectSearch"
            inputProps={{
              "data-testid": "remark-input",
            }}
            style={{ width: "100%" }}
          />
        </Grid>
      </Grid>
      {request_type.requestType === undefined && (
        <Grid
          container
          spacing={1}
          className={styles.myGrid}
          style={{ marginTop: "10px", justifyContent: "center" }}
          columns={12}
        >

           <Grid item md={2} lg={2} sm={2}>
            <div className={styles.rowDiv}>
              <div className={styles.formDiv}>
            <Button
              className={clsx(styles.actionButton, styles.primaryActionButton)}
              variant="primary"
              onClick={AdditionalNewAccessUserSave}
             disabled={disableButton}
              data-testid="confirm-action"
            
            >
              Save
            </Button>

            <Button
              className={clsx(styles.actionButton, styles.resetButton)}
              variant="tertiary"
              onClick={handleCancel}
              data-testid="confirm-action"
            >
              Cancel
            </Button>
            </div>
            </div>
          </Grid>
        </Grid>
      )}
    </div>
  );

  const renderSPOCRemark = () => (
    <div className={styles.formGroup}>
      <Grid
        container
        spacing={1}
        style={{
          marginTop: "10px",
        }}
        columns={12}
      >
        <Grid item md={2} lg={2} xs={2}>
          <div className={styles.rowDiv}>
            <div className={styles.lableDiv2}>
              <label>BC Head Remark</label>
            </div>
          </div>
        </Grid>
        <Grid item md={10} lg={10} xs={10}>
          <ValidatingTextField
            variant="outlined"
            isDisabled={bcHeadDisable}
            size="small"
            value={
              request_type.requestType === "AA-NA-SUP"
                ? emp_app_details[0]?.bc_remark || bcRemark
                : request_type.requestType === "AA-RTA-SUP"
                ? currentUserData?.bc_remark || bcRemark
                : request_type.requestType === "AA-NA-DS"
                ? emp_app_details[0]?.bc_remark || bcRemark
                : request_type.requestType === "AA-RTA-DS"
                ? currentUserData?.bc_remark || bcRemark
                : bcRemark
            }
            onChange={(event) => {
              const newValue = event.target.value;
              if (isValidInput(newValue)|| newValue === "") {
              setBcRemark(newValue);
              }
            }}
            name="projectSearch"
            inputProps={{
              "data-testid": "remark-input",
            }}
            style={{ width: "100%" }}
          />
        </Grid>
      </Grid>
    </div>
  );

  const renderSuperAdminRemark = () => (
    <div className={styles.formGroup}>
      <Grid
        container
        spacing={1}
        style={{
          marginTop: "10px",
        }}
        columns={12}
      >
        <Grid item md={2} lg={2} xs={2}>
          <div className={styles.rowDiv}>
            <div className={styles.lableDiv2}>
              <label>Super Admin Remark</label>
            </div>
          </div>
        </Grid>
        <Grid item md={10} lg={10} xs={10}>
          <ValidatingTextField
            variant="outlined"
            size="small"
            value={SARemark}
            onChange={(event) => {
              const newValue = event.target.value;
              if (isValidInput(newValue)|| newValue === "") {
              setSARemark(newValue);
              }
            }}
            name="projectSearch"
            inputProps={{
              "data-testid": "remark-input",
            }}
            style={{ width: "100%" }}
          />
        </Grid>
      </Grid>
    </div>
  );



  const validateFields = (fields) => {
    const requiredFields = { ...fields, ...fields.kamContactDetails };
    const hasMissingRequiredFields = Object.values(requiredFields).some(
      (field) => !field
    );

    const hasError = Object.values(errors).some((err) => err);

    if (hasMissingRequiredFields || hasError) {
      return false;
    }
    return true;
  };
  const resetAllInputs = () => {
    const inputs = {
      purchaseBuyerName: "",
      suppRepresentativeName: "",
      suppRepresentativeContact: "",
      suppRepresentativeEmail: "",
    };
    dispatch({ type: "update", field: "inputFields", value: inputs });
    dispatch({ type: "update", field: "errors", value: {} });
  };

  const resetState = () => {
    dispatch({ type: "reset" });
    resetAllInputs();
    resetTableData();
    setHighlightMandatoryFields(null);
    setResetAllVisitedFields(false);
    changeBackgroundColor("processInfoBg");
  };

  useEffect(() => {
    if (resetAllVisitedFields) resetState();
  }, [resetAllVisitedFields]);


  let Bflag=accessRole.includes("B")
  let saFlag=accessRole.includes("SA")

  const RedirectToDashboard = () => {
    const reqtype = requestType.split("-").shift();
    if (reqtype === "PL") {
      history.push("/linkage-dashboard");
      dispatchNew(setLogin({ ...auth, apiSendData: apiPayloadData}));
    }
    else {
      dispatchNew(setLogin({ ...auth, apiSendData: apiPayloadData}));
      history.push("/requestor-dashboard")
    }
  } 
  
  const gridFlag = request_type.activeId ? 11 : 12 ;

  return (
    <>
      {loadingTruck ? (
          <div style={{textAlign:"center",display:"flex",justifyContent:"center",marginTop:"40px"}}>
               <Truckloading />
            </div>):
               myState.tabelFlag && (
          <>{tableData.length > 0 && renderReport()}</>
        )}
      <>
        <Grid container spacing={0}>
            {request_type.activeId ? <Grid item md={1} lg={1} xs={1} sm={1} style={{ marginRight: '-30px'}}> 
              <ArrowCircleLeftIcon 
                  style={{
                    fontSize:'40px', 
                    color: "#608FC9", 
                    margin: '-4px 0px 1px 10px',
                    cursor: 'pointer'
                  }} 
                  onClick={() => RedirectToDashboard()}
              />
            </Grid>
             : "" }  
            <Grid item md={gridFlag} lg={gridFlag} xs={gridFlag} sm={gridFlag}> 
              <CustomFormGroup
                header="Additional Role Access"              
              />
            </Grid>
          </Grid>

        {renderroledetails()}
        </>
      {requestType === "" ? null : requestType === "NA" &&
        request_type.requestType === undefined && dropDownValue.length !==0 ? (
        <>
          {renderEmployeeDetails()}
          {dropDownValue.value === "DS" &&
            emp_app_details_status === "Success" && <>{renderBCDetails1()}</>}
        </>
      ) : requestType === "" ? null : requestType === "NA" &&
        request_type.requestType !== undefined ? (
        <>
          {renderTicketEmpDetails()}
          {requestRole === "DS" && <>{renderTicketBcDetails()}</>}
          {requestRole === "SUP" && <>{renderDetails()}</>}
          {renderUserRemark()}
          {Bflag || saFlag ? (
            <>
              {renderSPOCRemark()}
              {saFlag  ? renderSuperAdminRemark():''}
              {ApproveButtons()}
            </>
          ):''}
        </>
      ) : null}

      {requestType === "" ? null : requestType === "RTA" &&
        request_type.requestType === undefined && dropDownValue.length !==0 ? (
        <>
          {renderOther1()}
          
          {dropDownValue !== undefined && dropDownValue.value === "DS" &&
            emp_app_details_status === "Success" && <>{renderBCDetails1()}</>}
        </>
      ) : requestType === "" ? null : requestType === "RTA" &&
        request_type.requestType !== undefined ? (
        <>
          {renderTransferEmpDetails()}
          {requestRole === "DS" && <>{renderTicketBcDetails()}</>}
          {requestRole === "SUP" && <>{renderTicketApprovalDetailsDelete()}</>}
          {renderUserRemark()}
          {accessRole.includes("B") && (
            <>
              {renderSPOCRemark()}
              {ApproveButtons()}
            </>
          )}
          {accessRole.includes("SA") && (
            <>
              {renderSPOCRemark()}
              {renderSuperAdminRemark()}
              {ApproveButtons()}
            </>
          )}
        </>
      ) : null}
      {requestType === "NA" &&
        emp_app_details_status === "Success" &&
        dropDownValue.value === "DS" && 
        selectedBCInfo.length !== 0 &&  (
          <>{renderSpocApproval()}</>
        )}
      {requestType === "NA" &&
        emp_app_details_status === "Success" &&
        dropDownValue.value === "SUP" && (
          <>{renderDetails()}</>
        )}
      {requestType === "RTA" &&
        emp_app_details_status === "Success" &&
        currentTicket !== "" &&
        newAccessTicket === "" && (
          <>
            {dropDownValue.value === "DS" && selectedBCInfo?.length !== 0
              ? renderSpocApproval()
              : dropDownValue.value === "DS"
              ? null
              : renderApprovalDetailsDelete()}
          </>
        )}

      

      {requestType === "RTA" &&
        emp_app_details_status === "Success" &&
        currentTicket !== "" &&
        newAccessTicket !== "" && (
          <>
            {dropDownValue.value === "DS" && selectedBCInfo.length !== 0
              ? renderSpocApproval()
              : dropDownValue.value === "DS" && selectedBCInfo.length === 0
              ? null
              : renderApprovalDetailsDelete()}
          </>
        )}
      {request_type.requestType === undefined &&
      emp_app_details_status === "Success" ? (
        <>
          
          {renderUserRemark()}
       
        </>
      ) : null}

      <ResetModal
        isPopupOpen={isPopupOpen}
        handleClose={handleClose}
        resetFields={resetFields}
      />

      <ResetModal2
        a={confirmModalFlag2}
        handleCase={handleClose2}
        onDelete={() => onDeleteRow2(deleteParam2)}
      />
    </>
  );
}

function ResetModal2({ a, handleCase, onDelete }) {
  return (
    <Dialog
      open={a}
      className={styles.popContainer}
      classes={{
        paper: styles.popupBox,
      }}
      data-testid="reset-popup1"
    >
      <>
        <DialogTitle>
          <span className={styles.title}>
            <DeleteIcon style={{ height: "18px", width: "18px" }} />
            <span className={styles.txt}>Are you sure ?</span>
          </span>
        </DialogTitle>
        <DialogContent className={styles.content}>
          <span>Do you want to delete ?</span>
        </DialogContent>
        <DialogActions>
          <Button
            className={clsx(styles.actionButton, styles.transparentButton)}
            onClick={handleCase}
          >
            Cancel
          </Button>
          <Button
            className={clsx(styles.actionButton, styles.primaryActionButton)}
            variant="primary"
            onClick={onDelete}
          >
            Yes
          </Button>
        </DialogActions>
      </>
    </Dialog>
  );
}
function ResetModal1({ a, handleCase, onDelete }) {
  return (
    <Dialog
      open={a}
      className={styles.popContainer}
      classes={{
        paper: styles.popupBox,
      }}
      data-testid="reset-popup1"
    >
      <>
        <DialogTitle>
          <span className={styles.title}>
            <DeleteIcon style={{ height: "18px", width: "18px" }} />
            <span className={styles.txt}>Are you sure ?</span>
          </span>
        </DialogTitle>
        <DialogContent className={styles.content}>
          <span>Do you want to delete ?</span>
        </DialogContent>
        <DialogActions>
          <Button
            className={clsx(styles.actionButton, styles.transparentButton)}
            onClick={handleCase}
          >
            Cancel
          </Button>
          <Button
            className={clsx(styles.actionButton, styles.primaryActionButton)}
            variant="primary"
            onClick={onDelete}
          >
            Yes
          </Button>
        </DialogActions>
      </>
    </Dialog>
  );
}

function ResetModal({ isPopupOpen, handleClose, resetFields }) {
  return (
    <Dialog
      open={isPopupOpen}
      className={styles.popContainer}
      classes={{
        paper: styles.popupBox,
      }}
      data-testid="reset-popup"
    >
      <>
        <DialogTitle>
          <span className={styles.title}>
            <MdReplay style={{ height: "18px", width: "18px" }} />
            <span className={styles.txt}>Reset</span>
          </span>
        </DialogTitle>
        <DialogContent className={styles.content}>
          <span>Are you sure you want to reset the filters?</span>
        </DialogContent>
        <DialogActions>
          <Button
            className={clsx(styles.actionButton, styles.transparentButton)}
            onClick={handleClose}
          >
            Cancel
          </Button>
          <Button
            className={clsx(styles.actionButton, styles.primaryActionButton)}
            variant="primary"
            onClick={(e) => {
              e.preventDefault();
              handleClose();
              resetFields();
            }}
          >
            Yes
          </Button>
        </DialogActions>
      </>
    </Dialog>
  );
}

AccessControlForm.propTypes = {
  redirectToProcessPage: PropTypes.func,
};

ResetModal.propTypes = {
  isPopupOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  resetFields: PropTypes.func.isRequired,
};
ResetModal1.propTypes = {
  a: PropTypes.bool.isRequired,
  handleCase: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};
ResetModal2.propTypes = {
  a: PropTypes.bool.isRequired,
  handleCase: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  product: state.product,
  counter: state.counter.value,
  baseUrl: state.counter.baseUrl,
  auth: state.auth,
});
const mapDispatchToProps = (dispatch) => ({
    
});
AccessControlForm.propTypes = {
  counter: PropTypes.number,
  baseUrl: PropTypes.string,
  product: PropTypes.object,
  auth: PropTypes.object,
};
const App = connect(mapStateToProps, mapDispatchToProps)(AccessControlForm);

export default withAllowedOperationsProvider(App, RESOURCE_TYPE.PPAP);